import Vue from 'vue';

const EventBus = new Vue({});

export default EventBus;

/**
 * Global Events
 * - "clearData" 
 * - "langChanged"
 * - "urlChanged"
 */


// WEBPACK FOOTER //
// ./src/eventBus.js